import { useEffect, useRef } from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import "./styles/main.scss";

function App() {
  const cursorRef = useRef(null);
  useEffect(() => {
    //INFO: Adding Custom Cursor

    document.addEventListener("mousemove", (e) => {
      if (window.innerWidth <= 850) {
        return;
      }
      if (!cursorRef.current) {
        return;
      }
      let x = e.pageX;
      let y = e.pageY;

      cursorRef.current.style.display = "block";

      const cursorStyle = window.getComputedStyle(e.target)["cursor"];

      cursorRef.current.style.top = y - 3.5 + "px";
      cursorRef.current.style.left = x - 3.5 + "px";

      if (cursorStyle === "pointer") {
        cursorRef.current.classList.add("cursor-hover");
        return;
      }
      cursorRef.current.classList.remove("cursor-hover");
    });

    document.addEventListener("mouseout", () => {
      cursorRef.current.style.display = "none";
    });

    return () => {
      document.removeEventListener("mousemove", () => {});
    };
  }, [cursorRef]);

  return (
    <>
      <div ref={cursorRef} className="cursor"></div>
      <Navbar />
      <Hero />
      <About />
      <Projects />
      <Contact />
    </>
  );
}

export default App;
